import React, { useEffect, useRef, useState } from "react";
import Zoom from "@mui/material/Zoom";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import classes from "./MUIToolTip.module.css";
import Sources from "./Sources";
import api from "../../../BrandOnBoarding/api";
import MUIButton from "../MUIButton/MUIButton";
import Spinner from "../../Spinner/Spinner";
import LoadingSkeleton from "./LoadingSkeleton";
import { LLM_OPTIONS } from "../../../utils/constant";
import { formatDomainData } from "../../../luminaire/BrandAudit/Sources/sourcesOverview";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#353945",
    color: "#FCFCFD",
    boxShadow: theme.shadows[1],
    fontSize: 11,
    maxWidth: 500,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#353945",
  },
}));



export default function MUIToolTipBrandAudit({
  sources = [],
  actionText = "",
  children,
  title,
  metric,
  metricScore,
  addToActionHandler=()=>{},
  attribute,
  selectedInput,
  targetKey,
  isActionLoading,
  realtimeSources,
  isBrandScore = false,
  rating,
  sourceData,
  totalMetricScore =10,
  isDiscovery = false,
  ...props
}) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [source, setSource] = useState([]);
  const abortCtrlRef = useRef();
  const llm = selectedInput?.llm;
  const category = selectedInput?.category;
  const market = selectedInput?.market;
  useEffect(() => {
    // if (isBrandScore) {
      // setLoading(false);
      const newSources = extractSourceDomain(sourceData);
      setSource(newSources);
      // return
    // }
    // if (!open) {
    //   if (abortCtrlRef.current) {
    //     abortCtrlRef.current.abort();
    //   }
    //   setSource([]);
    //   return;
    // }
    // const timer = setTimeout(() => {
    //   getSources();
    // }, 1000);
    // return () => {
    //   if (timer) clearTimeout(timer);
    // };
  }, [open]);
  
  async function getSources() {
    abortCtrlRef.current = new AbortController();
    const additionalText = `${selectedInput?.brand} received a rating of ${metricScore} out of ${totalMetricScore}, a ${rating} score in ${attribute}`
    try {
      setLoading(true);
      const payload = {
        text_content: `
          ${additionalText}
  
          AdditionInfo: ${title}
          `,
      };
      const response = await api.post("/metrics/sources", payload, {
        signal: abortCtrlRef.current.signal,
      });
      const apiSources = response.data.citations.map((item) => item.source);
      const newSources = extractSourceDomain(sourceData, apiSources);
      setSource(newSources);
    } catch (error) {
      console.error("error occur in getSources", error)
    } finally {
      setLoading(false);
    }
  }
  const extractSourceDomain = (metricsSources, apiSources) => {
    const updateSources = {};
    const realSource = metricsSources || [];
    const llmSources = apiSources || [];
    const mergeSources = [...realSource, ...llmSources];
    updateSources[llm] = updateSources[llm] || {};
    updateSources[llm][category] = updateSources[llm][category] || {};
    updateSources[llm][category][market] = [
      ...new Set(mergeSources)
    ];

    let sourceAlias = formatDomainData(
      [llm],
      updateSources,
      [category],
      [market],
      "urls"
    );

    let finalSource = Object.entries(sourceAlias).map(([domain, urls]) => ({
      domain_url: domain,
      fullUrl: urls.map(u => u.url)
    }));
    finalSource = finalSource
      .sort((a, b) => b.fullUrl.length - a.fullUrl.length)
      .slice(0, 5);
    return finalSource
  }

  function handleTooltipOpen() {
    setOpen(true);
  }

  function handleTooltipClose() {
    setOpen(false);
  }

  function ToolTipContent({ actionText }) {
    const entity = selectedInput?.brand
      ? `brand ${selectedInput?.brand}`
      : `product ${selectedInput?.product}`;
    const actionStatement =totalMetricScore === 100 ? `The ${metric}-${attribute}`  : `The ${metric}-${attribute} score for the ${entity} is ${metricScore}`;
    const llmName = LLM_OPTIONS.find((option) => option.value === selectedInput?.llm)?.name;

    return (
      <div className={classes.content}>
        <h6>{typeof title === "string" ? title : actionStatement}</h6>
        <h6>Data Sources</h6>
        {/* {!isBrandScore && <span className="mb-2">Online</span>} */}
        {/* {loading && source.length === 0 ? (
          <LoadingSkeleton />
        ) : ( */}
          {source?.length > 0 && <Sources sources={source} />}
        {/* )} */}
       {!isDiscovery &&
        <div className={classes.action_btn_wrapper}>
          {isActionLoading ? (
            <Spinner />
          ) : (
            !loading && (
              <MUIButton
                size="small"
                className={classes.action_btn}
                variant="outlined"
                onClick={() =>
                  addToActionHandler(actionStatement, title, source, selectedInput?.brand,selectedInput?.llm)
                }
              >
                {actionText}
              </MUIButton>
            )
          )}
        </div>
       }
      </div>
    );
  }

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div className={classes.tooltip_wrapper}>
        <LightTooltip
          open={open}
          onOpen={handleTooltipOpen}
          onClose={handleTooltipClose}
          slots={{
            transition: Zoom,
          }}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          onClick={() => setOpen(true)}
          title={<ToolTipContent actionText={actionText} />}
          {...props}
        >
          {children}
        </LightTooltip>
      </div>
    </ClickAwayListener>
  );
}
